import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { EventBus } from '../event-bus.js';

const TOKEN_STORAGE_KEY = 'csml-editor-token';

// A chave de acesso chega por ?token= (o MA monta o iframe assim) e fica salva
// no navegador para os próximos acessos. Sai da URL para não ficar no histórico.
function loadEditorToken() {
  const params = new URLSearchParams(window.location.search);
  const fromUrl = params.get('token');
  if (fromUrl) {
    try { localStorage.setItem(TOKEN_STORAGE_KEY, fromUrl); } catch (e) { /* sem storage */ }
    params.delete('token');
    const query = params.toString();
    window.history.replaceState(null, '', window.location.pathname + (query ? `?${query}` : '') + window.location.hash);
    return fromUrl;
  }
  try { return localStorage.getItem(TOKEN_STORAGE_KEY) || ''; } catch (e) { return ''; }
}

// As chamadas vão para /api na mesma origem do editor. Quem fala com o
// csml-server e coloca a X-Api-Key é o proxy (nginx no Docker, devServer no dev).
const apiCSML = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'X-Editor-Token': loadEditorToken()
  }
});

apiCSML.interceptors.response.use(undefined, error => {
  if (error.response && error.response.status === 401) {
    const vencida = error.response.headers['x-editor-token-status'] === 'vencida';
    EventBus.$emit('add-console-message',
      `<span style="color: red;">Chave de acesso ${vencida ? 'vencida' : 'ausente ou inválida'}. ` +
      `Abra o editor pelo MA ou com ?token=&lt;chave&gt; no endereço.</span>`);
  }
  return Promise.reject(error);
});

// Mesmo formato que o MA monta em Integrations::Csml::ProcessorService, para o
// debug se comportar como em produção (sem módulos, sem callback_url).
function createBotPayload(sessionData, envData, botData) {
  return {
    id: sessionData.botID,
    name: sessionData.botID,
    env: envData,
    default_flow: 'Default',
    flows: [
      {
        id: 'Default_flow',
        name: 'Default',
        content: botData,
        commands: []
      }
    ]
  };
}

function clientParams(sessionData) {
  return {
    bot_id: sessionData.botID,
    channel_id: sessionData.channelID,
    user_id: sessionData.userID
  };
}

function createBotRunPayload(sessionData, metaData, botPayload, mensagem) {
  return {
    bot: botPayload,
    event: {
      request_id: uuidv4(),
      client: clientParams(sessionData),
      payload: {
        content_type: 'text',
        content: { text: mensagem }
      },
      metadata: metaData,
      ttl_duration: 10000
    }
  };
}

export default {
  getStatus() {
    return apiCSML.get('api/status');
  },
  runBot(sessionData, envData, metaData, botData, mensagem) {
    const botPayload = createBotPayload(sessionData, envData, botData);
    return apiCSML.post('api/run', createBotRunPayload(sessionData, metaData, botPayload, mensagem));
  },
  validateBot(sessionData, envData, botData) {
    return apiCSML.post('api/validate', createBotPayload(sessionData, envData, botData));
  },
  versionBot(sessionData, envData, botData) {
    return apiCSML.post('api/bots', createBotPayload(sessionData, envData, botData));
  },
  memoriesBot(sessionData) {
    return apiCSML.get('api/memories', { params: clientParams(sessionData) });
  },
  memoriesBotDelete(sessionData) {
    return apiCSML.delete('api/memories', { params: clientParams(sessionData) });
  },
  // Encerra a conversa: a próxima mensagem começa do zero (memórias ficam)
  closeConversation(sessionData) {
    return apiCSML.post('api/conversations/close', clientParams(sessionData));
  },
  restartServer() {
    return apiCSML.post('api/_control/restart');
  },
  serverHealth() {
    return apiCSML.get('api/_control/health');
  }
};
